<template>
    <div>
  <div class="main" v-if="scenes.deviceLinkageConditions!=undefined && scenes.deviceLinkageConditions.length>0" style="padding-left: 10px;padding-top: 10px;">
    <div class="mr-3" type="primary">场景 </div>
    <ul class="device clearfix">
      <li>
          <img  alt="" :src="$ftpUrl + deviceVo.icon" class="logo-img">
      </li>
      <li>
        <ul class="info clearfix">
          <li>{{scenes.sceneName}}</li>
          <li v-for="(item,index) in scenes.deviceLinkageConditions" :key="index">
              <span v-if="index!=0">
                  {{item.logicalOperator =='0'?"并且":"或者"}} —
              </span>
              <span v-else>
                  条件 ：
              </span>{{item.spaceName}} — {{item.deviceName}}
              <span v-if="item.devicePointName.length>0">— {{item.devicePointName}} — {{valueLogicalOperatorList[item.valueLogicalOperator]}} — {{item.pointValue}} ({{triggerTypeList[item.triggerType]}} )</span>
              <span v-else>(联动设备)</span>
          </li>
          <li>
<!--            <el-link :underline="false" class="mr-3" icon="el-icon-circle-close" type="warning">禁用</el-link>-->
            <el-link :underline="false" @touchstart="showUpdDialog" @click="showUpdDialog" class="mr-3" icon="el-icon-edit-outline" type="primary">编辑</el-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
        <div  class="main" v-else>
            <div style="text-align: center;margin-top: 61px;" >
                <el-button @touchstart="showDialog" @click="showDialog"><i class="el-icon-circle-plus-outline"></i> 新增场景</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "LinkageDeviceItem",
    props:["scenes","deviceVo"],
    components:{},
    data() {
      return {
          scene:'',
          valueLogicalOperatorList:[
              '小于',
              '大于',
              '等于',
              '不等于',
              '大于等于',
              '小于等于'
          ],
          triggerTypeList:[
              '每次',
              '单次'
          ],
      }
    },
    watch: {
        scenes(newVal){
            this.scene=newVal;
        }
    },
    methods:{
       showDialog(){
          this.$emit("showDialog", '新增场景','Scene',true,'40vw',this.scenes);
      },
        showUpdDialog(){
            this.$emit("showDialog", '编辑场景','Scene',true,'40vw',this.scenes);
        }
    }
}
</script>

<style scoped>
.main {
  width: 100%;
  min-height: 162px;
  background: rgba(41, 155, 255, 0.1);
  border: 1px solid #299BFF;
  border-radius: 2px;
}

.device {
  margin-top: 20px;
}

.device li {
  list-style: none;
  float: left;
}

.info li {
  float: none;
  margin-bottom: 5px;
}

.control li {
  float: left;
}

</style>
